<!-- Component that implements a list of documents -->
<template lang="html">
  <div>
    <v-data-table
    :headers="headers"
    :items="listaBolsas"
    :search="search"
    :no-data-text="'Este projeto não possui bolsas.'"
    must-sort
    :sort-by.sync="sortBy"
    :sort-desc.sync="sortDesc"
    :items-per-page="itemsPerPage"
    :footer-props="{itemsPerPageText: 'Linhas por página', itemsPerPageOptions: opcoesPaginacao}"

    >
      <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
        Mostrando {{ pageStart }} a {{ pageStop }} de {{ listaBolsas.length }} bolsas
      </template>
    </v-data-table>

    <v-divider></v-divider>
    <v-card-actions v-if="administrador === true || (projeto.situacao.item !== 16 && projeto.funcao != null && projeto.funcao.item === 1)">
      <v-btn v-if="!extensao.registroSIEX" class="text-xs-right" color="primary" @click="submissaoAprovacao">Submeter para aprovação</v-btn>
      <v-btn v-else class="text-xs-right" color="primary" @click="concluirImportacao">Concluir Importação</v-btn>
      <v-btn class="text-xs-right" color="primary" @click="toRelatorio">Gerar PDF da Ação</v-btn>
      <v-spacer></v-spacer>
      <c-hint-btn v-if="administrador" color="primary" @click="toAlocar" tooltip="Alocar uma ou mais bolsas em ação de extensão">Alocar bolsa</c-hint-btn>
      <c-hint-btn :disabled="listaBolsas.length === 0" color="primary" @click="toAtribuir" tooltip="Indicar um estudante de graduação da Ufes como bolsista">Indicar bolsista</c-hint-btn>
      <v-btn color="primary" text @click="toAvancar" >Avançar</v-btn>
    </v-card-actions>
    <v-card-actions v-else>
      <v-btn v-if="usuarioPROEX === true || administrador === true || (projeto.funcao != null && projeto.funcao.item === 1)" class="text-xs-right" color="primary" @click="toRelatorio">Gerar PDF da Ação</v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
import HintButton from '@/components/c-hint-btn'
import dates from '@/utils/dates'
import projetos from '@/utils/projetos'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['idProjeto', 'projeto', 'extensao'],
  data: () => ({
    listaBolsas: [],
    dates: dates,
    search: null,
    sortBy: 'total',
    sortDesc: false,
    itemsPerPage: 10,
    opcoesPaginacao: [ 10, 20, 30, {text: 'Todas', value: -1} ],
    headers: [
      { text: 'Número', align: 'center', value: 'idBolsa' },
      { text: 'Código', align: 'center', value: 'codigo' },
      { text: 'Descrição', align: 'center', value: 'descricao' },
      { text: 'Bolsistas', align: 'center', value: 'ocupadas' },
      { text: 'Bolsas', align: 'center', value: 'total' }
    ]
  }),
  computed: {
    ...mapGetters('auth', ['logged', 'administrador'])
  },
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING']),
    truncate (string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...'
      else return string
    },
    toAtribuir: function () {
      this.$router.push({name: 'AtribuirBolsa', params: {idProjeto: this.idProjeto}})
    },
    toAlocar: function () {
      this.$router.push({name: 'AlocarBolsa', params: {idProjeto: this.idProjeto}})
    },
    toAvancar: function () {
      this.$router.push({ name: 'ArquivosProjeto', params: {idProjeto: this.idProjeto} })
    },
    submissaoAprovacao: function () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Submetendo Projeto.' })
      projetos.postSubmissaoAprovacao(this.idProjeto)
      .then(response => {
        alert('O cadastro da ação nesta plataforma não garante o registro! É necessário autuar um processo digital (com PDF do Projeto em anexo) na secretaria do setor de lotação do coordenador e aguardar deliberação da Câmara de Extensão. Maiores informações entre em contato através do e-mail suporte.proex@ufes.br')
        this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
        this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Submetendo Projeto.' })
      })
    },
    concluirImportacao: function () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Concluindo importação...' })
      projetos.postConcluirImportacao(this.idProjeto)
      .then(response => {
        this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
        this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Concluindo importação...' })
      })
    },
    toRelatorio: function () {
      this.$router.push({ name: 'Relatorio', params: {idProjeto: this.idProjeto} })
    }
  },
  mounted () {
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando bolsas.' })
    projetos.getBolsasDoProjeto(this.idProjeto)
    .then(response => {
      this.listaBolsas = response.data.slice()
    })
    .catch(error => {
      console.log('Erro ao mandar o request' + error)
    })
    .finally(() => {
      this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando bolsas.' })
    })
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'tooltip': ToolTip,
    'c-hint-btn': HintButton
  }
}
</script>

<style lang="css" slot-scoped>
</style>



// WEBPACK FOOTER //
// projeto-bolsas-tabela.vue?166bd104